var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 376V424C512 437.255 501.255 448 488 448H448V488C448 501.255 437.255 512 424 512H376C362.745 512 352 501.255 352 488V205.25L205.25 352H320V448H88C74.745 448 64 437.255 64 424V160H24C10.745 160 0 149.255 0 136V88C0 74.745 10.745 64 24 64H64V24C64 10.745 74.745 0 88 0H136C149.255 0 160 10.745 160 24V306.75L306.75 160H192V64H402.75L457.378 9.372C469.874 -3.124 490.133 -3.124 502.628 9.372L502.628 9.372C515.124 21.867 515.124 42.126 502.628 54.622L448 109.25V352H488C501.255 352 512 362.745 512 376Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.d0def300c38e753b2250f28fbebc4eaa.svg";
export { ForwardRef as ReactComponent };